export default {
  title: "Graphique de tendance",
  recent_records: "Enregistrements récents",
  preview_report: "Aperçu du rapport",
  compliant_status_good: "Bon statut de conformité",
  custom_factor_status: "Utilisation d'un facteur personnalisé, statut de conformité en attente",
  tax_amount: "Montant de la taxe",
  based_on_eur: "Basé sur €{amount}",
  total_emission: "Émission totale",
  recent_calculation_date: "Date de calcul récente",
  no_records: "Aucun enregistrement",
  calculate_now: "Calculer maintenant",
  cbam_news: "Actualités CBAM",
  no_news: "Aucune actualité",
  usage_stats_and_price: "Statistiques d'utilisation et prix du carbone",
  monthly_calculation_count: "Nombre de calculs mensuels",
  monthly_report_count: "Nombre de rapports mensuels",
  monthly_avg_emission: "Émission moyenne mensuelle",
  today_carbon_price: "Prix du carbone aujourd'hui",
  current_plan: "Plan actuel : {plan}",
  upgrade_now: "Passer à la version supérieure maintenant",
  trial_remaining: "{days} jours restants, {calculations} calculs, {reports} rapports",
  expiry_date: "Date d'expiration : {date}",
  free_plan_desc1: "100 calculs par mois, 1 rapport par jour",
  free_plan_desc2: "Passez à la version supérieure pour débloquer davantage de fonctionnalités !",
  trial_expired: "Essai expiré, passez au plan pro (99 €/mois) pour continuer",
  config_fetch_failed: "Échec de la récupération de la configuration",
};
